module.exports = __webpack_public_path__ + "img/wzzt - 副本.52df1757.png";